import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthLayout from '@/components/common/AuthLayout';
import { Button } from '@/components/ui/button';

type AuthLinkErrorPageProps = Readonly<{
  variant: 'expired' | 'error';
}>;

export default function AuthLinkErrorPage({ variant }: AuthLinkErrorPageProps) {
  const { t } = useTranslation('auth');
  const scope = variant === 'expired' ? 'linkExpired' : 'linkError';

  return (
    <AuthLayout title={t(`${scope}.title`)} background="gradient">
      <div className="space-y-16">
        <p className="text-sm text-secondary-inverse">{t(`${scope}.message`)}</p>

        <Button className="w-full text-base h-11" asChild>
          <Link to="/forgot-password">{t(`${scope}.cta`)}</Link>
        </Button>

        <p className="text-sm text-secondary-inverse">
          {t('checkSpamMessage')} <span className="text-button-secondary">{t('supportEmail')}</span>
        </p>
      </div>
    </AuthLayout>
  );
}
